import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { User } from '@/store/user'
import { userQueryKey, getCurrentUser } from '@/lib/actions.ts'

export const useFetchUser = (): UseQueryResult<User, Error> => {
  return useQuery<User, Error>({
    queryKey: userQueryKey,
    queryFn: getCurrentUser,
    // Don't throw on error - let ProtectedRoute handle offline/error states gracefully
    // This prevents the error boundary from catching network errors on cold start
    throwOnError: false,
  })
}
